// extracted by mini-css-extract-plugin
export default {"desktopContainer":"Laptop_desktopContainer__58G86","desktop":"Laptop_desktop__QU53A","desktopScreen":"Laptop_desktopScreen__uf8wX"};